export const masterObjectTypes = [
  { value: 1, label: 'Portfolio' },
  { value: 2, label: 'Peer Group' },
  { value: 3, label: 'Holding' }
];

export const fillerBenchmarks = [
  {
    benchmarkId: null,
    name: '',
    isVisible: true,
    id: 'first_filler_bench'
  },
  {
    benchmarkId: null,
    name: '',
    isVisible: false,
    id: 'second_filler_bench'
  },
  {
    benchmarkId: null,
    name: '',
    isVisible: false,
    id: 'third_filler_bench'
  },
  {
    benchmarkId: null,
    name: '',
    isVisible: false,
    id: 'fourth_filler_bench'
  },
  {
    benchmarkId: null,
    name: '',
    isVisible: false,
    id: 'fifth_filler_bench'
  },
  {
    benchmarkId: null,
    name: '',
    isVisible: false,
    id: 'sixth_filler_bench'
  }
];

export const options = [
  {
    title: 'Display the legend of the widget',
    name: 'isLegendDisplayed'
  },
  {
    title: 'Display the title of the widget',
    name: 'isTitleDisplayed'
  },
  {
    title: 'Display the date range of the widget',
    name: 'isDateDisplayed'
  },
  {
    title: 'Display the info tooltip on hover',
    name: 'isChartTooltipDisplayed'
  }
];

export const widthOptions = [
  {
    label: '16%',
    value: 2
  },
  {
    label: '25%',
    value: 3
  },
  {
    label: '33%',
    value: 4
  },
  {
    label: '42%',
    value: 5
  },
  {
    label: '50%',
    value: 6
  },
  {
    label: '67%',
    value: 8
  },
  {
    label: '75%',
    value: 9
  },
  {
    label: '83%',
    value: 10
  },
  {
    label: '100%',
    value: 12
  }
];

export const dateTypeOptions = [
  {
    title: 'Dynamic Date ',
    value: 'dynamicDate'
  },
  {
    title: 'Custom Date ',
    value: 'customDate'
  }
];

export const dynamicDateOptions = [
  { title: 'Inception To Date', value: 1 },
  { title: 'Year To Date', value: 2 },
  {
    title: 'Last 12 Months',
    value: 3
  },
  {
    title: 'Last 12 Months Less One Month  ',
    value: 4
  },
  {
    title: 'Last 24 Months',
    value: 5
  },
  {
    title: 'Last 36 Months',
    value: 6
  }
];

export const dateMatchTypeOptions = [
  {
    title: 'All Dates ',
    value: 1
  },
  {
    title: 'Common Start Date ',
    value: 2
  },
  {
    title: 'Intersection',
    value: 3
  }
];

export const generateEmptyRecord = benchmarks => {
  if (benchmarks && benchmarks.length && benchmarks.length > 0) {
    const enrichedBenchmarks = [...benchmarks].map((benchmark, index) => ({
      ...benchmark,
      benchmarkId: benchmark.benchmarkId || benchmark.timeSerieId || benchmark.id,
      id: fillerBenchmarks[index].id,
      isVisible: benchmark.name !== '' && benchmark.name !== benchmark.id
    }));

    return [...enrichedBenchmarks, ...fillerBenchmarks.slice(benchmarks.length)];
  }

  return fillerBenchmarks;
};

export const layouts = [
  {
    id: 1,
    title: 'Layout A',
    slots: 11,
    class: 'layoutA'
  },
  {
    id: 2,
    title: 'Layout B (Holding Master)',
    slots: 10,
    class: 'layoutB'
  },
  {
    id: 3,
    title: 'Layout C (Portfolio Master)',
    slots: 12,
    class: 'layoutC'
  },
  {
    id: 4,
    title: 'Layout D (Holding Master variant)',
    slots: 13,
    class: 'layoutD'
  },
  {
    id: 5,
    title: 'Layout E',
    slots: 10,
    class: 'layoutE'
  },
  {
    id: 6,
    title: 'Layout G',
    slots: 30,
    class: 'layoutG'
  },
  {
    id: 7,
    title: 'Layout H',
    slots: 20,
    class: 'layoutH'
  },
  {
    id: 8,
    title: 'Layout I',
    slots: 15,
    class: 'layoutI'
  },
  {
    id: 9,
    title: 'Layout J',
    slots: 10,
    class: 'layoutJ'
  },
  {
    id: 10,
    title: 'Layout K',
    slots: 5,
    class: 'layoutK'
  },
  {
    id: 11,
    title: 'Layout L',
    slots: 1,
    class: 'layoutL'
  },
  {
    id: 12,
    title: 'Layout M',
    slots: 2,
    class: 'layoutM'
  },
  {
    id: 13,
    title: 'Layout N',
    slots: 4,
    class: 'layoutN'
  },
  {
    id: 14,
    title: 'Layout O',
    slots: 4,
    class: 'layoutO'
  }
];
